import { PropsWithChildren } from "react"
import { useAppSelector } from "../store/storeHooks"
import { UserType } from "../login/loginTypes"
import { selectEffectiveUserType } from "../context/contextSelectors"

type MatchContextUserTypeProps = Readonly<
    PropsWithChildren<{
        userTypes: UserType[]
    }>
>

export function MatchContextUserType({ userTypes, children }: MatchContextUserTypeProps) {
    const userType = useAppSelector(selectEffectiveUserType)

    if (userType && userTypes.includes(userType)) {
        return <>{children}</>
    }

    return null
}
